import { render, staticRenderFns } from "./startProductDevelopment.vue?vue&type=template&id=6dbd0454&scoped=true&"
import script from "./startProductDevelopment.vue?vue&type=script&lang=js&"
export * from "./startProductDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./startProductDevelopment.vue?vue&type=style&index=0&id=6dbd0454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd0454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbd0454')) {
      api.createRecord('6dbd0454', component.options)
    } else {
      api.reload('6dbd0454', component.options)
    }
    module.hot.accept("./startProductDevelopment.vue?vue&type=template&id=6dbd0454&scoped=true&", function () {
      api.rerender('6dbd0454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/prekickoff/startProductDevelopment.vue"
export default component.exports